/* eslint-disable prettier/prettier */
"use strict";

import { FindStatus } from "./pdf_find_controller.js";

/**
 * Creates a "search bar" given a set of DOM elements that act as controls
 * for searching or for setting search preferences in the UI. This object
 * also sets up the appropriate events for the controls. Actual searching
 * is done by PDFFindController.
 * @ignore
 */
class PDFFindBar {
  constructor(options) {
    this.bar = options.bar || null;
    this.findField = options.findField || null;
    this.highlightAll = options.highlightAllCheckbox || null;
    this.wholeWord = options.wholeWord || null;
    this.caseSensitive = options.caseSensitiveCheckbox || null;
    this.findMsg = options.findMsg || null;
    this.findResultsCount = options.findResultsCount || null;
    this.findPreviousButton = options.findPreviousButton || null;
    this.findNextButton = options.findNextButton || null;
    this.searchButton = options.searchButton || null;
    this.searchResult = options.searchResult || null;
    this.findResultCurrent = options.findResultCurrent || null;
    this._app = options.app || null;

    // Add event listeners to the DOM elements.
    const self = this;

    this.bar.addEventListener("keydown", function (event) {
      switch (event.keyCode) {
        case 13: // Enter
          if (event.target === self.findField) {
            self.dispatchEvent("again", event.shiftKey);
          }
          break;
        case 27: // Escape
          self.reset();
      }
    });

    this.findField.addEventListener("input", function () {
      self.searchButton.classList.toggle(
        "tw2018css_cancel",
        self.findField.value
      );

      if (!self.findField.value) {
        self.reset();
      }

      self.dispatchEvent("");
    });

    this.searchButton.addEventListener("click", function () {
      if (this.classList.contains("tw2018css_cancel")) {
        self.reset();
      }
    });

    this.findPreviousButton.addEventListener("click", function (event) {
      if (event.defaultPrevented) {
        return;
      }

      self.dispatchEvent("again", true);
    });

    this.findNextButton.addEventListener("click", function (event) {
      if (event.defaultPrevented) {
        return;
      }

      self.dispatchEvent("again", false);
    });

    this.highlightAll.addEventListener("click", function () {
      self.dispatchEvent("highlightallchange");
    });

    this.wholeWord.addEventListener("click", function () {
      self.dispatchEvent("wholewordchange");
    });

    this.caseSensitive.addEventListener("click", function () {
      self.dispatchEvent("casesensitivitychange");
    });
  }

  dispatchEvent(type, findPrev) {
    const event = document.createEvent("CustomEvent");
    event.initCustomEvent("find" + type, true, true, {
      query: this.findField.value,
      caseSensitive: this.caseSensitive.checked,
      highlightAll: this.highlightAll.checked,
      findPrevious: findPrev,
      wholeWord: this.wholeWord.checked,
    });
    return this.bar.dispatchEvent(event);
  }

  updateUIState(findStatus, previous, matchCount, currentMatch) {
    let findMsgText = "";
    let findStatusText = "";

    switch (findStatus) {
      case FindStatus.FIND_FOUND:
        break;

      case FindStatus.FIND_PENDING:
        findStatusText = "pending";
        break;

      case FindStatus.FIND_NOTFOUND:
        findMsgText = this._app.texts.text_not_found;
        break;

      case FindStatus.FIND_WRAPPED:
        findMsgText = previous
          ? this._app.texts.find_reached_top
          : this._app.texts.find_reached_bottom;
        break;
    }

    this.findField.setAttribute("data-status", findStatusText);
    if (findMsgText) {
      const coords = this._app.toolbar.getSearchOptionsCoordinate();
      this.findMsg.parentElement.style.top = coords.y + 5 + "px";
    }

    this.findMsg.parentElement.style.display = findMsgText ? "block" : "none";
    this.findMsg.textContent = findMsgText;

    this.updateResultsCount(currentMatch, matchCount);
  }

  updateResultsCount(currentMatch, matchCount) {
    if (!this.findResultsCount) {
      return; // no UI control is provided
    }

    if (matchCount === undefined) {
      this.findField.value = "";
      this.searchButton.classList.remove("tw2018css_cancel");
      this.searchResult.classList.add("tw2018css_hidden");
      this.findResultsCount.textContent = "";
      this.findResultCurrent.textContent = "";
      return;
    }

    // Create the match counter
    this.findResultsCount.textContent = matchCount.toLocaleString();
    this.findResultCurrent.textContent = currentMatch.toLocaleString() + " /";
    if (this.searchResult.getBoundingClientRect().width > 50) {
      this.findResultsCount.textContent = "";
      this.findResultCurrent.textContent = "";
    } else {
      if (matchCount > 0) {
        this.searchResult.classList.remove("tw2018css_hidden");
      }
    }
  }

  reset() {
    this.findField.value = "";
    this.dispatchEvent("");
    this.updateUIState();
  }
}

export { PDFFindBar };
